import React, { useEffect, useState } from 'react'

function Classes() {
  const [trainnerData,setTrainnerData]=useState([])
  const dataArray=[
    {image:"/images/weigthLoss.png",
     name:"Weight Loss",
     description:"Burn calories and boost your metabolism with our high energy weight loss classes."
    },
    {image:"/images/yoga.png",
      name:"Basic Yoga",
      description:"Find balance, flexibility, andinner peace with our beginner friendly yoga sessions."
    },
    {image:"/images/calisthenics.png",
      name:"Calisthenics",
      description:"Master bodyweight movements to build functional strength and endurance."
    },
    {   image:"/images/bodyBuilding.png",
        name:"Body Building",
        description:"Sculpt and strengthen your physique with targeted body building classes."
      }
  ]
  useEffect(()=>{
    setTrainnerData(dataArray)
  },[])
  return (
    <div className='mt-8 md:mt-10 w-full h-auto p-6 md:p-10 aling-center justify-center text-center'>
     <h1 className='text-white font-[700] text-xl sm:text-2xl md:text-3xl '>Our Classes</h1>
     <p className='text-md sm:text-lg md:text-lg text-center m-auto w-[96%] md:w-[60%]  mt-4 md:mt-6 text-nav_option'>
            Our vision is to build a vibrant fitness community where people of all 
            backgrounds can discover their potential, break barriers, and transform 
            their lives. By fostering a culture of passion, dedication, and innovation, 
            Fit Streak strives to become a leader in the fitness industry and a trusted 
            partner in every fitness journey.
          </p>
      <div className='mt-10 flex flex-col lg:flex-row w-[90%] lg:w-[100%] xl:w-[85%] 2xl:w-[80%]  m-auto justify-between'>
    
            <div id='WeightLoss'
              className="w-[90%] m-auto sm:w-[85%] md:w-[70%] lg:w-[230px] xl:w-[250px] 2xl:w-[280px] mt-6 lg:m-0 relative hover:border hover:border-red bg-[#1c1c1c] h-auto z-0 rounded-[10px]"
            >
              <img src='/images/weigthLoss.png' alt="male trainer" className="w-full h-auto rounded-t-[10px]" />
              <div className="w-[100%] h-auto md:h-48 bg-custom-gradient  text-left absolute bottom-0 z-10 rounded-b-[10px] p-4 item-end">
                <h1 className="text-lg xxs:text-md md:text-xl lg:text-xl text-white font-bold mt-[20%] lg:mt-[38%] xl:mt-[30%]">
                Weight Loss
                </h1>
                <h2 className="text-md xxs:text-xs md:text-md lg:text-xs xl:text-md text-nav_option font-semibold">
                  Burn calories and boost your metabolism with our high energy weight loss classes.
                </h2>
              </div>
            </div>
            <div
              id='BasicYoga'
              className="w-[90%] m-auto sm:w-[85%] md:w-[70%] lg:w-[230px] xl:w-[250px] 2xl:w-[280px] mt-6 lg:m-0 relative hover:border hover:border-red bg-[#1c1c1c] h-auto z-0 rounded-[10px]"
            >
              <img src='/images/yoga.png' alt="male trainer" className="w-full h-auto rounded-t-[10px]" />
              <div className="w-[100%] h-auto md:h-48 bg-custom-gradient  text-left absolute bottom-0 z-10 rounded-b-[10px] p-4 item-end">
                <h1 className="text-lg xxs:text-md md:text-xl lg:text-xl text-white font-bold mt-[20%] lg:mt-[38%] xl:mt-[30%]">
                  Basic Yoga
                </h1>
                <h2 className="text-md xxs:text-xs md:text-md lg:text-xs xl:text-md text-nav_option font-semibold">
                  Find balance, flexibility, andinner peace with our beginner friendly yoga sessions.
                </h2>
              </div>
            </div>
            <div
              id='Calisthenics'
              className="w-[90%] m-auto sm:w-[85%] md:w-[70%] lg:w-[230px] xl:w-[250px] 2xl:w-[280px] mt-6 lg:m-0 relative hover:border hover:border-red bg-[#1c1c1c] h-auto z-0 rounded-[10px]"
            >
              <img src='/images/calisthenics.png' alt="male trainer" className="w-full h-auto rounded-t-[10px]" />
              <div className="w-[100%] h-auto md:h-48 bg-custom-gradient  text-left absolute bottom-0 z-10 rounded-b-[10px] p-4 item-end">
                <h1 className="text-lg xxs:text-md md:text-xl lg:text-xl text-white font-bold mt-[20%] lg:mt-[38%] xl:mt-[30%]">
                Calisthenics
                </h1>
                <h2 className="text-md xxs:text-xs md:text-md lg:text-xs xl:text-md text-nav_option font-semibold">
                Master bodyweight movements to build functional strength and endurance.
                </h2>
              </div>
            </div>
            <div
              id='BodyBuilding'
              className="w-[90%] m-auto sm:w-[85%] md:w-[70%] lg:w-[230px] xl:w-[250px] 2xl:w-[280px] mt-6 lg:m-0 relative hover:border hover:border-red bg-[#1c1c1c] h-auto z-0 rounded-[10px]"
            >
              <img src='/images/bodyBuilding.png' alt="male trainer" className="w-full h-auto rounded-t-[10px]" />
              <div className="w-[100%] h-auto md:h-48 bg-custom-gradient  text-left absolute bottom-0 z-10 rounded-b-[10px] p-4 item-end">
                <h1 className="text-lg xxs:text-md md:text-xl lg:text-xl text-white font-bold mt-[20%] lg:mt-[38%] xl:mt-[30%]">
                Body Building
                </h1>
                <h2 className="text-md xxs:text-xs md:text-md lg:text-xs xl:text-md text-nav_option font-semibold">
                Sculpt and strengthen your physique with targeted body building classes.
                </h2>
              </div>
            </div>
      </div>    
    </div>
  )
}

export default Classes
